//@ts-check
import getSearchParams from "../url/getSearchParams";
import parseUrl from "../url/parseUrl";

var enhancer = function enhancer(customHistory) {
  var initialHistoryStackSize = window.history.length;
  customHistory.returnEntries = customHistory.returnEntries || [];
  var entries = customHistory.returnEntries;
  customHistory.returnEntryIndex = entries.length - 1;
  /**
   * Acts like a close button, usually by going back
   */

  customHistory.return = function () {
    var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/"; //search the hints through history entries
    //respect returnUrl if is present in url

    var hints = path;
    if (typeof path === "string") hints = [path];
    var returnUrlParam = getSearchParams(customHistory.location).returnUrl;

    if (returnUrlParam) {
      if (!returnUrlParam.startsWith("/")) returnUrlParam = "/" + returnUrlParam;
      hints = [returnUrlParam];
    }

    var urlToReturn = hints.filter(function (h) {
      return h.indexOf(":") === -1;
    })[0];
    if (!urlToReturn) urlToReturn = '/';
    var index = 1;
    var goBack = false;

    for (var i = customHistory.returnEntryIndex; i >= 0; i--) {
      index--;
      var entryPath = parseUrl(entries[i]).url;
      var foundHint = false;

      for (var hintIdx = 0; hintIdx < hints.length; hintIdx++) {
        var hint = hints[hintIdx];
        var hitMatched = true;
        var hintSegments = hint.split("/");
        var entrySegments = entryPath.split("/");

        for (var segIdx = 0; segIdx < Math.max(hintSegments.length, entrySegments.length); segIdx++) {
          var hintSeg = hintSegments[segIdx];
          var entrySeg = entrySegments[segIdx];

          if (hintSeg === entrySeg) {//exact match
          } else if (hintSeg && hintSeg.indexOf(":") > -1) {//matches any parameter
          } else {
            //no match
            hitMatched = false;
            break;
          }
        }

        if (hitMatched) {
          urlToReturn = entries[i];
          goBack = true;
          foundHint = true;
          break;
        }
      }

      if (foundHint) break;
    }

    if (goBack) {
      //verify if someone else navigated the url without using history
      // for e.g. navigation inside an iframe
      if (initialHistoryStackSize + customHistory.returnEntries.length !== window.history.length) {
        // because we don't know the number of entries added by the iframe
        //  we can't go back, so fallback to push
        goBack = false;
      }
    }

    if (goBack) customHistory.go(index);else customHistory.push(urlToReturn);
  };

  var nativePush = customHistory.push;

  customHistory.push = function (path, state) {
    if (customHistory.returnEntryIndex > -1) {
      entries.splice(customHistory.returnEntryIndex + 1, customHistory.length - customHistory.returnEntryIndex);
    }

    entries.push(path);
    customHistory.returnEntryIndex = entries.length - 1;
    return nativePush(path, state);
  };

  var nativeReplace = customHistory.replace;

  customHistory.replace = function (path, state) {
    if (customHistory.returnEntryIndex > -1) entries[customHistory.returnEntryIndex] = path;
    customHistory.returnEntryIndex = entries.length - 1;
    return nativeReplace(path, state);
  };

  var nativeGo = customHistory.go;

  customHistory.go = function (n) {
    customHistory.returnEntryIndex += n;
    return nativeGo(n);
  };

  return customHistory;
};

export default enhancer;